import React from 'react';

export const HeaderDropdownColor = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="10.0833" height="10.0833" rx="2.75" fill="#F87FB1" />
      <rect
        x="11.918"
        width="10.0833"
        height="10.0833"
        rx="2.75"
        fill="#F6B495"
      />
      <rect
        y="11.918"
        width="10.0833"
        height="10.0833"
        rx="2.75"
        fill="#FDE5EF"
      />
      <rect
        x="11.918"
        y="11.918"
        width="10.0833"
        height="10.0833"
        rx="2.75"
        fill="#5DD099"
      />
    </svg>
  );
};
